import React from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { UDV_SURFACE, udvDialogProps } from './udvSurface'

/**
 * Compare local vs push payload when StudyInstanceUID already in catalog.
 */
const StudyDuplicateDlg = ({
  open,
  payload,
  localCatalog,
  busy,
  error,
  onKeep,
  onReplace,
  onReject,
  onClose,
}) => {
  const p = payload || {}
  const local = localCatalog || {}
  const patient = p.patient_name || local.patientName || 'Paciente'
  const remoteN =
    p.received_instances != null
      ? Number(p.received_instances)
      : p.expected_instances != null
        ? Number(p.expected_instances)
        : null
  const localN = local.instanceCount != null ? Number(local.instanceCount) : 0

  return (
    <Dialog
      open={!!open}
      onClose={busy ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      {...udvDialogProps}
    >
      <DialogTitle style={UDV_SURFACE.title}>Estudio ya en storage local</DialogTitle>
      <DialogContent style={UDV_SURFACE.content}>
        <Typography variant="body1" gutterBottom style={{ fontWeight: 600, color: '#f0f4f8' }}>
          {patient}
        </Typography>
        <Typography
          variant="body2"
          style={{ wordBreak: 'break-all', ...UDV_SURFACE.muted }}
          gutterBottom
        >
          {p.study_instance_uid || local.studyInstanceUID}
        </Typography>
        <Typography variant="body2" gutterBottom style={{ color: 'rgba(210, 220, 230, 0.92)' }}>
          Local: <strong>{localN}</strong> instancias
          {remoteN != null ? (
            <>
              {' '}
              · Gateway: <strong>{remoteN}</strong> instancias
              {localN === remoteN ? ' (mismo conteo)' : ' (diferente conteo)'}
            </>
          ) : null}
        </Typography>
        <Typography variant="body2" style={UDV_SURFACE.muted}>
          Mantener deja la copia local. Reemplazar borra y vuelve a descargar. Rechazar
          avisa al Gateway y no cambia el storage.
        </Typography>
        {error && (
          <Typography style={{ marginTop: 12, color: '#ff8a80' }}>{error}</Typography>
        )}
        {busy && (
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 12 }}>
            <CircularProgress size={18} style={{ marginRight: 10 }} />
            <Typography variant="body2" style={UDV_SURFACE.muted}>
              Procesando…
            </Typography>
          </div>
        )}
      </DialogContent>
      <DialogActions style={UDV_SURFACE.actions}>
        <Button onClick={onReject} style={UDV_SURFACE.btnDanger} disabled={busy}>
          Rechazar
        </Button>
        <Button onClick={onKeep} style={UDV_SURFACE.btnGhost} disabled={busy}>
          Mantener
        </Button>
        <Button
          onClick={onReplace}
          style={UDV_SURFACE.btnPrimary}
          variant="contained"
          disabled={busy}
          autoFocus
        >
          Reemplazar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default StudyDuplicateDlg
